import {
  CircularProgress,
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from "@material-ui/core";
import {
  FormHelperText,
  InputAdornment,
  MenuItem,
  TextField
} from "@material-ui/core";
import classNames from "classnames";
import { Field, FieldProps } from "formik";
import React from "react";
import checkmark from "../assets/images/check-mark.svg";

export interface IBB8FieldProps {
  name?: string;
  label?: string;
  id?: string;
  disabled?: boolean;
  defaultValue?: any;
  error?: any;
  status?: any;
  touched?: boolean;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
  placeholder?: string;
  validate?: any;
  value?: any;
}

interface IBB8FormFieldProps extends IBB8FieldProps, WithStyles {
  ranges?: any[];
  required?: boolean;
  type?: string;
  validAdornment?: boolean;
  loadingAdornment?: boolean;
  maxLength?: number;
  autoFocus?: boolean;
  loading?: boolean;
}

export const BB8InnerFormField: React.SFC<IBB8FormFieldProps> = props => (
  <div className={props.classes.root} style={{ flexDirection: "column" }}>
    <FormHelperText
      style={{ marginLeft: 8 }}
      error={!!props.error}
      id="component-error-text"
    >
      {props.label}
    </FormHelperText>
    <TextField
      id={props.id}
      name={props.name}
      className={classNames(props.classes.margin, props.classes.textField)}
      variant="outlined"
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
      helperText={props.error}
      error={!!props.error}
      disabled={props.disabled || false}
      placeholder={props.placeholder}
      select={!!props.ranges}
      required={props.required}
      type={props.type}
      InputProps={TextFieldAdornments(
        props.validAdornment,
        props.loadingAdornment,
        props.loading,
        !props.error
      )}
      inputProps={{
        autoCapitalize: "on",
        maxLength: props.maxLength
      }}
      autoFocus={props.autoFocus}
    >
      {props.ranges &&
        props.ranges.map((option: any) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </TextField>
  </div>
);

function TextFieldAdornments(
  validAdornment?: boolean,
  loadingAdornment?: boolean,
  loading?: boolean,
  valid?: boolean
) {
  if (loadingAdornment && loading) {
    return {
      endAdornment: (
        <InputAdornment position="end">
          <CircularProgress />
        </InputAdornment>
      )
    };
  }
  if (validAdornment && valid) {
    return {
      endAdornment: (
        <InputAdornment position="end">
          <img alt="checkmark-success" src={checkmark} />
        </InputAdornment>
      )
    };
  }
  return {};
}

/**
 * This component wraps BB8Form Field with Formik Field component. For more details
 * please check {@link https://jaredpalmer.com/formik/docs/api/field}
 * @param props Form field props
 */
const BB8FormField = (props: IBB8FormFieldProps) => (
  <Field name={props.name} validate={props.validate}>
    {({ field, form }: FieldProps) => {
      return (
        <BB8InnerFormField
          {...props}
          {...field}
          // triggers formik onChange and also the passed in onChange from the caller
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => {
            field.onChange(e);
            if (props.onChange) {
              props.onChange(e.target.value);
            }
          }}
          error={
            props.error || (form.touched[field.name] && form.errors[field.name])
          }
          value={props.value || (form.values && form.values[field.name])}
        />
      );
    }}
  </Field>
);

const styles = createStyles((theme: Theme) => ({
  margin: {
    margin: theme.spacing.unit
  },
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    flexBasis: 100
  }
}));

export default withStyles(styles)(BB8FormField);
